import React, {Component} from 'react';
import classes from './Contents.css';
import Banner from './Banner/Banner';
import Dept from './Lists/Dept/Dept';
import Subs from './Lists/Subs/Subs';
import { Route, Switch } from 'react-router-dom';

class Contents extends Component{
    state = {
        heading : 'Departments',
        deptName : 'CSE'
    }
    showSubs = (department) => {
        this.setState({deptName : department, heading : 'Subjects'});
    }
    componentWillReceiveProps() {
        if (window.location.pathname !== '/subs') {
            this.setState({heading : 'Departments'})
        }
    }
    render () {
        return (
            <div className = {classes.Contents}>
                <Banner heading={this.state.heading}/>
                <Switch>
                    <Route path='/' exact render={(props) => (<Dept clicked = {this.showSubs} {...props}/>)} />
                    <Route path='/subs' render={(props) => (<Subs deptName = {this.state.deptName} {...props}/>)} />
                </Switch>
            </div>
        )
    }
}

export default Contents;


// WEBPACK FOOTER //
// ./src/components/Contents/Contents.js